import React from 'react';
import PropTypes from 'prop-types';
import { CodeHighlighter } from '@uhg-abyss/web/ui/CodeHighlighter';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Tabs } from '@uhg-abyss/web/ui/Tabs';
import { SchemaTableV3 } from './SchemaTableV3.jsx';

const BodyContainer = styled('div', {
  marginTop: 24,
});

export const BodyV3 = ({ body, currentApi }) => {
  const formattedCode = JSON.stringify(body, null, 2);

  return (
    <BodyContainer>
      <Tabs title="Arrow Variant" variant="arrow">
        <Tabs.Tab label="Schema">
          <SchemaTableV3 currentApi={currentApi} />
        </Tabs.Tab>
        <Tabs.Tab label="Sample">
          <CodeHighlighter
            language="js"
            code={formattedCode}
            maxHeight="450px"
          />
        </Tabs.Tab>
      </Tabs>
    </BodyContainer>
  );
};

BodyV3.propTypes = {
  body: PropTypes.shape({}),
  currentApi: PropTypes.shape({}).isRequired,
};

BodyV3.defaultProps = {
  body: null,
};
